<template>
  <div>
    <div class="unpaid-lab" v-if="isHasUnpaid" @click="toOrderRecord">
      <img src="../../images/unpaid_tip.png" />
      <span> 当前有未支付订单,请尽快支付!</span>
      <img src="../../images/disclosure.png" class="right-icon" />
    </div>
    <van-swipe
      class="my-swipe"
      :autoplay="3000"
      lazy-render
      indicator-color="white"
    >
      <van-swipe-item v-for="item in swipeList" :key="item" >
        <img :src="item.hostUrl" class="swipe_img"  @click="btnSwipe(item.retrun_url)"/>
      </van-swipe-item>
    </van-swipe>
  </div>
  <div class="sticky">
    <van-dropdown-menu active-color="#0082FF">
      <van-dropdown-item
        v-model="state.value"
        :options="dropdownvalue"
        @change="filterResult"
      />
      <van-dropdown-item title="筛选" ref="item">
        <p class="d-i-t">电桩类型</p> 
        <div class="d-m-r l-b">
          <block v-for="(item, index) in state.filterList" :key="item">
            <div
              class="block item-block"
              :class="{ selected: item.isSelect, default: !item.isSelect }"
              @click="chargeType(index)"
            >
              {{ item.text }}
            </div>
          </block>
        </div>
        <div class="d-m-r">
          <div class="fliter-btn btn-left" @click="onCancle">取消</div>
          <div class="fliter-btn btn-right" @click="onConfirm">确定</div>
        </div>
      </van-dropdown-item>
    </van-dropdown-menu>
  </div>
  <HomeList :sort="filterData" :stationType="stationType" />
</template>

<script>
import HomeList from "../../components/HomeList.vue";
import { ref, reactive } from "vue";
import request from "@/api/request";
import tokenHelper from "@/helpers/token_helper";
import { useRouter } from "vue-router";
let swipeList = ref([]);
let isHasUnpaid = ref(false);
let router;
export default {
  components: {
    HomeList,
  },
  setup() {
    const item = ref(null);
    router = useRouter();
    const state = reactive({
      value: "distance",
      filterList: [
        { text: "直流", isSelect: false, value: "dc" },
        { text: "交流", isSelect: false, value: "ac" },
      ],
    });
    let filterData = ref(state.value); //筛选条件
    const dropdownvalue = [
      { text: "距离最近", value: "distance" },
      { text: "低价优先", value: "price" },
    ];
    const onCancle = () => {
      item.value.toggle(); //隐藏弹窗
    };
    let stationType = ref("");
    const onConfirm = () => {
      item.value.toggle(); //隐藏弹窗
      stationType.value = formatefilster(state.filterList);
    };
    if (tokenHelper.readAccessToken() != null) {
      checkUnpaidOrder();
    }
    function formatefilster(filterList) {
      let value_list = [];
      for (var i = 0; i < filterList.length; i++) {
        let list = filterList[i];
        if (list.isSelect) {
          value_list.push(list.value);
        }
      }
      if ([...new Set(value_list)].length >= 2) {
        return ""; //如果都勾选返回空，子控件不传参数
      }
      return [...new Set(value_list)].toString();
    }
    //筛选直流交流
    function chargeType(index) {
      state.filterList[index].isSelect = !state.filterList[index].isSelect;
    }
    //筛选距离和价格
    function filterResult(value) {
      filterData.value = value;
    }
    function toOrderRecord() {
      router.push("/user/orders_list");
    }
    return {
      item,
      state,
      dropdownvalue,
      onConfirm,
      toOrderRecord,
      onCancle,
      isHasUnpaid,
      filterData,
      swipeList,
      stationType,
      chargeType,
      btnSwipe,
      filterResult,
    };
  },
  created() {
    this.getSwipeAPi();
  },
  methods: {
    getSwipeAPi() {
      request
        .getHomeSwipe({
          visible_on_login: false,
          ad_type: "slideshow",
        })
        .then((res) => {
          const results = res?.data?.results || []; // 没有就用空数组
          if(results.length > 0){
            swipeList.value = this.formateImage(res.data.results);
          }
        });
    },
    formateImage(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        element.hostUrl =
          window.location.origin.replace("-webapp", "") + element.ad_pic.url;
      }
      return array;
    },
  },
};
function checkUnpaidOrder() {
  let param = {};
  param["status"] = "unpaid";
  request.getOrderList(param).then((res) => {
    isHasUnpaid.value = res.data.results.length != 0;
  });
}
function btnSwipe(event){
  window.open(event, '_blank')
}
</script>

<style lang="scss" scoped>
body {
  margin: 0px !important;
  padding: 0px !important;
}
.d-i-t {
  color: rgb(105, 99, 99);
  font-size: 12px;
  text-align: left;
  margin: 18px 0px 0px 10px;
}
.d-m-r {
  display: flex;
}
.block {
  border-radius: 5px;
  padding: 0px 15px;
  margin-right: 10px;
}
.btn-left {
  color: #1a1a1a;
}
.btn-right {
  color: #fff;
  background: #0082ff;
}
.l-b {
  margin: 10px 10px;
}
.default {
  border: 1px solid #ebebeb;
  color: #1a1a1a;
}
.selected {
  border: 1px solid #0082ff;
  color: #0082ff;
}

.fliter-btn {
  flex: 1;
  text-align: center;
  line-height: 46px;
  border-top: 1px solid #eee;
}
.sticky {
  position: sticky;
  background: #f1f2f3;
  z-index: 888;
  top: 0px;
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
  background: none;
}
::v-deep.van-dropdown-menu__item {
  flex: none;
  margin-left: 20px;
}
::v-deep.van-dropdown-menu__title {
  color: #1a1a1a;
}
::v-deep.van-dropdown-menu__title::after {
  border-color: transparent transparent #1a1a1a #1a1a1a;
}
::v-deep.van-dropdown-menu__title--active::after {
  border-color: transparent transparent #0082ff #0082ff;
}
::v-deep.van-swipe {
  height: 140px;
  border-radius: 5px;
  margin: 10px 15px 0px 15px;
  background: #fff;
}
.item-block {
  height: 28px;
  line-height: 28px;
}
.swipe_img {
  width: 100%;
  height: 100%;
}
.unpaid-lab {
  z-index: 999;
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  padding: 10px 15px;
  align-items: center;
  justify-items: center;
  background: #fff6f6;
}
.unpaid-lab img {
  width: 15px;
  height: 15px;
  margin: auto 0;
  vertical-align: middle;
}

.unpaid-lab span {
  color: #fb0006;
  font-size: 14px;
}
.right-icon {
  width: 22px !important;
  height: 22px !important;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 15px;
}
</style>